import notificationsActions, {
  NotificationOptions,
} from '../modules/notifications/actions';
import { Store } from 'redux';

class NotificationHelper {
  private successMessage: string | null;
  private failureMessage: string;
  private options: NotificationOptions;

  constructor(
    successMessage?: string | null,
    failureMessage?: string,
    options?: NotificationOptions,
  ) {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    this.successMessage = successMessage;
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    this.failureMessage = failureMessage;
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    this.options = options;
  }

  getAsyncRequestSuccessHandler() {
    if (!this.successMessage) return null;

    const successOptions: NotificationOptions = {
      ...this.options,
      statusType: 'success',
    };

    return (store: Store) => {
      store.dispatch(
        notificationsActions.addNotification(
          this.successMessage || '',
          successOptions,
        ),
      );
    };
  }

  getAsyncRequestFailureHandler() {
    if (!this.failureMessage) return null;

    const failureOptions: NotificationOptions = {
      ...this.options,
      statusType: 'error',
    };

    return (store: Store) => {
      store.dispatch(
        notificationsActions.addNotification(
          this.failureMessage,
          failureOptions,
        ),
      );
    };
  }

  getAsyncRequestHandlers() {
    const onSuccess = this.getAsyncRequestSuccessHandler();
    const onFailure = this.getAsyncRequestFailureHandler();

    return Object.assign(
      {},
      onSuccess && { onSuccess },
      onFailure && { onFailure },
    );
  }
}

export default NotificationHelper;
